module.exports = __webpack_public_path__ + "img/Warning.23d05f36.svg";